import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const InvitesPage = lazy(() => import('./InvitesPage'));

const InvitesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.UserManagement,
  routes: [
    {
      path: 'invites',
      element: <InvitesPage />,
    },
  ],
};

export default InvitesConfig;
